import State from 'store/State';
import { useSelector } from 'react-redux';

export const selectAppSettings = (state: State) => state.app.appSettings;

export const selectUsersSymbology = (state: State) =>
    selectAppSettings(state).symbology;

export const selectCombineSellsAndShorts = (state: State) =>
    selectAppSettings(state).combineSellsAndShorts;

export const useSelectAppSettings = () =>
    useSelector((state: State) => selectAppSettings(state));

export const useSelectAlwaysShowMenuBar = () => {
    const appSettings = useSelectAppSettings();
    return appSettings.alwaysShowMenuBar;
};

export const useSelectCombineSellsAndShorts = () => {
    const appSettings = useSelectAppSettings();
    return appSettings.combineSellsAndShorts;
};

export const useShowBuysAsPositive = () => {
    const appSettings = useSelectAppSettings();
    return appSettings.showBuysAsPositive;
};

export const useSelectIsAppToolbarHidden = () =>
    useSelectAppSettings().hideAppToolbar;
